import {Action} from '@ngrx/store';
import {IngenieroAgronomoCore} from "../../../../../chacra-core/models/ingenieros-agronomos";

export enum IngenierosAgronomosActionTypes {
  INGENIEROSAGRONOMOS_LOAD_REQUEST = '[INGENIEROSAGRONOMOS] Load Request',
  INGENIEROSAGRONOMOS_LOAD_FAILURE = '[INGENIEROSAGRONOMOS] Load Failure',
  INGENIEROSAGRONOMOS_LOAD_SUCCESS = '[INGENIEROSAGRONOMOS] Load Success'
}

// load

export class IngenierosAgronomosLoadRequestAction implements Action {
  readonly type =
    IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_REQUEST;
}

export class IngenierosAgronomosLoadFailureAction implements Action {
  readonly type =
    IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class IngenierosAgronomosLoadSuccessAction implements Action {
  readonly type =
    IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_SUCCESS;

  constructor(public payload: { items: IngenieroAgronomoCore[] }) {
  }
}

// actions

export type IngenierosAgronomosActions =
  | IngenierosAgronomosLoadRequestAction
  | IngenierosAgronomosLoadFailureAction
  | IngenierosAgronomosLoadSuccessAction;
